export const staffPermissionDefinitions = [
    { id: "dashboard.read", label: "查看经营概览" },
    { id: "orders.read", label: "查看订单" },
    { id: "orders.write", label: "处理和取消订单" },
    { id: "orders.create", label: "代客下单" },
    { id: "orders.export", label: "导出订单" },
    { id: "payments.write", label: "登记和冲销收款" },
    { id: "products.read", label: "查看商品" },
    { id: "products.write", label: "管理商品和 SKU" },
    { id: "categories.read", label: "查看分类" },
    { id: "categories.write", label: "管理分类" },
    { id: "inventory.read", label: "查看库存" },
    { id: "inventory.write", label: "登记和冲销库存" },
    { id: "promotions.read", label: "查看促销" },
    { id: "promotions.write", label: "管理促销" },
    { id: "imports.read", label: "查看数据导入和下载模板" },
    { id: "imports.write", label: "导入数据" },
    { id: "customers.read", label: "查看客户" },
    { id: "customers.write", label: "管理客户" },
    { id: "staff.read", label: "查看内部账号" },
    { id: "audit.read", label: "查看操作日志" },
];
const permissionIds = staffPermissionDefinitions.map(({ id }) => id);
const permissionIdSet = new Set(permissionIds);
const dependencies = {
    "orders.write": ["orders.read"],
    "orders.create": ["orders.read", "customers.read"],
    "orders.export": ["orders.read"],
    "payments.write": ["orders.read"],
    "products.read": ["categories.read"],
    "products.write": ["products.read"],
    "categories.write": ["categories.read"],
    "inventory.read": ["categories.read"],
    "inventory.write": ["inventory.read"],
    "promotions.write": ["promotions.read", "products.read"],
    "imports.write": ["imports.read"],
    "customers.write": ["customers.read"],
};
/** Keep only known permissions and include the read permissions needed by each action. */
export function normalizeStaffPermissions(keys = []) {
    const selected = new Set();
    function add(key) {
        if (selected.has(key))
            return;
        selected.add(key);
        for (const dependency of dependencies[key] ?? [])
            add(dependency);
    }
    for (const key of keys) {
        if (typeof key === "string" && permissionIdSet.has(key))
            add(key);
    }
    return permissionIds.filter((id) => selected.has(id));
}
export function getStaffPermissions(user) {
    if (!user || (user.accountType !== undefined && user.accountType !== "STAFF"))
        return [];
    if (user.staffRole === "ADMIN")
        return [...permissionIds];
    if (user.staffRole === "VIEWER") {
        return permissionIds.filter((id) => id.endsWith(".read") || id === "orders.export");
    }
    if (user.staffRole === "CUSTOM")
        return normalizeStaffPermissions(user.staffPermissions ?? []);
    return [];
}
export function hasStaffPermission(user, key) {
    return getStaffPermissions(user).includes(key);
}
export const dealerPermissionDefinitions = [
    { id: "catalog.read", label: "查看商品目录" },
    { id: "orders.create", label: "购物车和提交订单" },
    { id: "orders.read", label: "查看我的订单" },
    { id: "addresses.read", label: "查看和维护收货地址" },
];
const dealerPermissionIds = dealerPermissionDefinitions.map(({ id }) => id);
const dealerPermissionIdSet = new Set(dealerPermissionIds);
export function normalizeDealerPermissions(keys = []) {
    const selected = new Set();
    for (const key of keys) {
        if (typeof key === "string" && dealerPermissionIdSet.has(key))
            selected.add(key);
    }
    if (selected.has("orders.create")) {
        selected.add("catalog.read");
        selected.add("addresses.read");
    }
    return dealerPermissionIds.filter((id) => selected.has(id));
}
export function getDealerPermissions(user) {
    if (!user || (user.accountType !== undefined && user.accountType !== "DEALER"))
        return [];
    // Null is the migration-compatible value for existing customer accounts.
    if (user.dealerPermissions == null)
        return [...dealerPermissionIds];
    return normalizeDealerPermissions(user.dealerPermissions);
}
export function hasDealerPermission(user, key) {
    return getDealerPermissions(user).includes(key);
}
